export default __webpack_public_path__ + "static/media/IMG_1616.8a43a4f5.jpg";